import styled from '@emotion/styled';
import { useEffect, useState } from 'react';

import { round } from '../../lib/math';
import { ToastManager } from '../../ToastManager';

import { useMount } from '../../hooks/useMount';
import { useApi, useSelectedHomeyConnection } from '../../store/SelectedHomeyStore.hooks';

import { su } from '../../theme/functions/su';
import { theme } from '../../theme/theme';

import { Heading4 } from '../../components/common/text/Heading4';

export function Weather() {
  const { api } = useApi();
  const { connectionEpoch } = useSelectedHomeyConnection();
  const [state, setState] = useState('');
  const mount = useMount();

  useEffect(() => {
    function setter(result) {
      const temperature = round(result.temperature ?? 0, 0);
      const temperatureUnits = result.temperatureUnits ?? '°C';
      const weatherState = result.state ?? '';
      const message = weatherState
        ? `${temperature} ${temperatureUnits} • ${weatherState}`
        : `${temperature} ${temperatureUnits}`;

      if (mount.isMounted) {
        setState(message);
      }
    }

    if (api) {
      api.weather.connect().catch(ToastManager.handleError);
      api.weather
        .getWeather()
        .then(setter)
        .catch((error) => {});
      api.weather.on('weather', setter);
    }

    return function () {
      if (api) {
        api.weather.off('weather', setter);
        api.weather.disconnect().catch(ToastManager.handleError);
      }
    };
  }, [api, mount, connectionEpoch]);

  return (
    <sc.Weather lineHeight="24px" color={theme.color.text_light}>
      {state}
    </sc.Weather>
  );
}

const sc = {};

sc.Weather = styled(Heading4)`
  margin-top: ${su(1)};
  min-height: 24px;
`;
